angular.module('webtrader').component('tabs', {
  templateUrl: (Account) => {
    return BASE_URL+'templates/component.tabs.html'
  },
  controller: function (Account, Trades) {

    this.trades = Trades;
    this.account = Account;
    this.activeTab = 0;
    this.showAll = false;

    this.changeTab = (hiddenIndex) => {
      this.tabs.unshift(this.tabs.splice(hiddenIndex, 1)[0]);
      this.activeTab = 0;
    }
  }
});